import React, { CSSProperties, FC } from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import FadeBox from 'src/components/FadeBox';
import { AnimatedStat } from 'src/components/AnimatedStat';

const LoadingSkeleton = () => {
  return (
    <Skeleton
      variant="text"
      sx={{
        fontSize: 40,
        width: ({ spacing }) => spacing(5),
        height: ({ spacing }) => spacing(5),
        transform: 'none',
        // borderRadius: '10px',
      }}
    />
  );
};

interface StatContentProps {
  value?: string;
  type: string;
  loading?: boolean;
  statPrefix?: string;
  statSuffix?: string;
  statStyle?: CSSProperties;
}

const DEFAULT_STAT_STYLE: CSSProperties = {
  fontWeight: 700,
  lineHeight: 1,
};

const StatContent: FC<StatContentProps> = ({
  value = '',
  type,
  statStyle = DEFAULT_STAT_STYLE,
  statPrefix,
  statSuffix,
  loading = false,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      flexWrap="nowrap"
      alignItems="center"
      justifyContent="center"
    >
      {loading ? (
        <LoadingSkeleton />
      ) : (
        <FadeBox loading={loading}>
          <AnimatedStat
            value={value}
            addedCellStyle={statStyle}
            prefix={statPrefix}
            suffix={statSuffix}
          />
        </FadeBox>
      )}
      <Typography fontSize={20} fontWeight={550} letterSpacing={-0.5}>
        {type}
      </Typography>
    </Box>
  );
};

export default StatContent;
